function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ruler-pencil-line",
  transform: "translate(-2 -0.994)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11576",
  "data-name": "Path 11576",
  d: "M9,17.41v8.433h8.433l-1.759-1.759H10.759V19.169Z",
  transform: "translate(-0.844 -1.98)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11577",
  "data-name": "Path 11577",
  d: "M30.906,28.516l-2.524-2.559v2.3H3.759V24.611H5.518V23.2H3.759V17.356H5.518V15.949H3.759V10.321H5.518V8.914H3.759V4L17.776,17.936v-2.48L3.5,1.254A.879.879,0,0,0,2,1.879V29.14a.879.879,0,0,0,.879.879h27.4a.879.879,0,0,0,.624-1.5Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11578",
  "data-name": "Path 11578",
  d: "M23.759,26.8h3.518a1.759,1.759,0,0,0,1.759-1.759V8.069l-2.023-3.72a1.768,1.768,0,0,0-3.1.07L22,8.087V25.041A1.759,1.759,0,0,0,23.759,26.8Zm0-18.291,1.706-3.315,1.812,3.324V21.524H23.759Zm0,14.448h3.518V25.1H23.759Z",
  transform: "translate(-2.412 -0.299)",
  fill: "#ac1ede"
}));

var SvgRulerPencilLine = function SvgRulerPencilLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.166,
    height: 29.025,
    viewBox: "0 0 29.166 29.025",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRulerPencilLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ruler-pencil-line.7b7b7b59.svg";
export { ForwardRef as ReactComponent };